import {
  Checkbox,
  Col,
  Form,
  InputNumber,
  Row,
  Select,
  UploadFile,
} from "antd";
import * as S from "../Multistepform.styles";
import AppartementsFormList from "../components/AppartementsFormList";
import VillasFormList from "../components/VillasFormList";
import BureauxFormList from "../components/BureauxFormList";
import CommercialsFormList from "../components/LcFormList";
import UploadList from "../components/UploadList";

interface Props {
  form: any;
  formData: any;
  setFormData: any;
  fileListBureauVente: UploadFile[];
  setFileListBureauVente: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  fileListExterieurProjet: UploadFile[];
  setFileListExterieurProjet: React.Dispatch<
    React.SetStateAction<UploadFile[]>
  >;
  fileListTemoins: UploadFile[];
  setFileListTemoins: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  fileListPiscine: UploadFile[];
  setFileListPiscine: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  fileListParking: UploadFile[];
  setFileListParking: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  fileListChantier: UploadFile[];
  setFileListChantier: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  fileListEquipmentSportif: UploadFile[];
  setFileListEquipmentSportif: React.Dispatch<
    React.SetStateAction<UploadFile[]>
  >;
  fileListAutres: UploadFile[];
  setFileListAutres: React.Dispatch<React.SetStateAction<UploadFile[]>>;
}
export const UploadStep: React.FC<Props> = ({
  form,
  formData,
  setFormData,
  fileListBureauVente,
  setFileListBureauVente,
  fileListExterieurProjet,
  setFileListExterieurProjet,
  fileListTemoins,
  setFileListTemoins,
  fileListPiscine,
  setFileListPiscine,
  fileListParking,
  setFileListParking,
  fileListChantier,
  setFileListChantier,
  fileListEquipmentSportif,
  setFileListEquipmentSportif,
  fileListAutres,
  setFileListAutres,
}) => {
  return (
    <Row style={{ width: "100%", padding: "20px" }}>
      {formData.bureau_de_vente === "disponible" && (
        <>
          <S.SpanLined>Bureau de Vente</S.SpanLined>
          <UploadList
            fileList={fileListBureauVente}
            setFileList={setFileListBureauVente}
          />
        </>
      )}
      <S.SpanLined>Extérieur du projet</S.SpanLined>
      <UploadList
        fileList={fileListExterieurProjet}
        setFileList={setFileListExterieurProjet}
      />
      {formData.phase_du_projet === "en chantier" && (
        <>
          <S.SpanLined>Construction/Chantier</S.SpanLined>
          <UploadList
            fileList={fileListChantier}
            setFileList={setFileListChantier}
          />
        </>
      )}
      <S.SpanLined>Témoins</S.SpanLined>
      <UploadList fileList={fileListTemoins} setFileList={setFileListTemoins} />
      {formData.piscine === true && (
        <>
          <S.SpanLined>Piscine</S.SpanLined>
          <UploadList
            fileList={fileListPiscine}
            setFileList={setFileListPiscine}
          />
        </>
      )}
      {(formData.parking_appartements || formData.parking_villas) && (
        <>
          <S.SpanLined>Parking</S.SpanLined>
          <UploadList
            fileList={fileListParking}
            setFileList={setFileListParking}
          />
        </>
      )}

      {(formData.salle_de_sport || formData.terrain_de_sport) && (
        <>
          <S.SpanLined>Equipements Sportifs</S.SpanLined>
          <UploadList
            fileList={fileListEquipmentSportif}
            setFileList={setFileListEquipmentSportif}
          />
        </>
      )}

      <S.SpanLined>Autres</S.SpanLined>
      <UploadList fileList={fileListAutres} setFileList={setFileListAutres} />
    </Row>
  );
};
